import React from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

export default function TermsAndCondition() {

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.2,
      },
    },
  };

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <>
      <Header />

      <section className="text-black py-16 px-4 md:px-10">
        <motion.div
          variants={container}
          initial="hidden"
          animate="visible"
          className="max-w-5xl mx-auto"
        >
          <motion.h1
            variants={fadeUp}
            className="text-4xl md:text-5xl font-bold mb-10 text-blue-800"
          >
            Terms & Conditions
          </motion.h1>

          <motion.div
            variants={fadeUp}
            className="space-y-6 text-black leading-8 text-justify"
          >

            <h2 className="text-2xl font-semibold">Terms & Conditions</h2>

            <p>
              Kindly read the following Terms and Conditions carefully before continuing.
            </p>

            <p>
              By selecting “I Agree” or “I Accept”, or by downloading, installing, or using the services, you expressly acknowledge your consent to be bound by these Terms and Conditions. This constitutes a legally enforceable agreement between you and <Link to="https://kisgaleasing.com" target='_blank'> Kisga Leasing and Finance Pvt Ltd.</Link>, including its lending partners.
            </p>

            <h3 className="text-xl font-semibold">Definitions</h3>

            <p>
              “Application” refers to the digital software platform developed by the Company for providing lending-related services, branded as B4SALARY. “Lender” means <Link to="https://kisgaleasing.com" target='_blank'> Kisga Leasing and Finance Pvt Ltd.</Link> and/or its authorized lending partners. “Lending Partner” denotes any bank or non-banking financial company associated with the Company through a lending arrangement. “Company”, “We”, or “Us” refers to Kisga Leasing and Finance Pvt Ltd., a Non-Banking Financial Company incorporated in Delhi, India.
            </p>

            <p>
              “Loan” means the financial facility applied for through the Platform and sanctioned by the Lender subject to applicable terms. “Loan Agreement” refers to the binding agreement executed between the customer and the Lender, either electronically or physically. “App” refers to the mobile application made available to users.
            </p>

            <p>
              “Outstanding Amount” includes the principal loan amount, accrued interest, and applicable fees payable to the Lender. “Platform” includes both the mobile application and website. “Services” refer to loan-related facilitation provided through the Platform. “Third-Party Platforms” include social networking websites such as LinkedIn or Facebook. “User Data” includes all personal, financial, and documentary information submitted by you. “Website” means the Company’s official online portal.
            </p>

            <h3 className="text-xl font-semibold">Services</h3>

            <p>
              The Services enable eligible users to apply for loans through the Platform. By availing these Services, you acknowledge that the Company is authorized to collect, verify, store, and process your User Data and documents as required by the Lender for loan assessment and approval.
            </p>

            <p>
              Access to the Services requires registration on the Platform. During the application process, you will be required to submit personal, identification, and financial information, including but not limited to your name, contact details, date of birth, photographs, banking details, PAN, income information, and credit-related data. By registering, you authorize the Company to retrieve and verify such data from third-party sources and credit bureaus as permitted by law.
            </p>

            <p>
              Upon successful submission and verification of your information through the Mobile Application Form (MOF), your application will be evaluated based on the Lender’s eligibility criteria. If approved, you may be required to complete additional documentation such as ECS/NACH mandates or other lender-mandated formalities prior to loan disbursement.
            </p>

            <p>
              Loan amounts, once approved, will be disbursed as per the instructions provided by you in the application. You are solely responsible for timely repayment of the loan in accordance with the agreed repayment schedule.
            </p>

            <p>
              You further acknowledge and consent that the Company may monitor your location while you are using the Services and until all outstanding dues are cleared, even if you uninstall the App or discontinue usage.
            </p>

            <p>
              Any termination or discontinuation of the Services does not absolve you of your repayment obligations. You are responsible for maintaining the confidentiality of your login credentials. The Company reserves the right to approve or reject registrations at its sole discretion.
            </p>

            <p>
              By accepting these Terms, you authorize the Company to store and process your User Data for authentication, verification, and service-related purposes.
            </p>

            <h3 className="text-xl font-semibold">Licence</h3>

            <p>
              Subject to compliance with these Terms, the Company grants you a limited, non-transferable, and revocable license to download, install, and use the App on compatible devices. The App is licensed, not sold. The Company may provide updates or maintenance at its discretion and is not obligated to support older versions.
            </p>

            <h3 className="text-xl font-semibold">Restrictions</h3>

            <p>
              You agree not to misuse the Platform or Services, including engaging in fraudulent, unlawful, or abusive conduct. You must not copy, modify, resell, distribute, or exploit any part of the Platform. Uploading malicious software, offensive content, or engaging in unauthorized solicitation is strictly prohibited.
            </p>

            <p>
              Any actions intended to disrupt the Platform, violate applicable laws, or infringe the rights of others are not permitted and may result in immediate termination of Services.
            </p>

            <h3 className="text-xl font-semibold">Content Availability</h3>

            <p>
              The Company does not guarantee the accuracy, reliability, or completeness of any content available on the Platform. All content is provided on an “as-is” basis, unless expressly stated otherwise.
            </p>

            <h3 className="text-xl font-semibold">Proprietary Rights</h3>

            <p>
              All intellectual property rights related to the Platform, including trademarks, logos, and content, remain the exclusive property of the Company. Unauthorized use of such materials is prohibited and may attract legal consequences.
            </p>

            <h3 className="text-xl font-semibold">Third-Party Links</h3>

            <p>
              The Platform may contain links to external websites operated by third parties. The Company does not control or endorse these sites and shall not be responsible for their content or practices.
            </p>

            <h3 className="text-xl font-semibold">Termination</h3>

            <p>
              The Company may terminate these Terms in the event of breach, legal requirement, service discontinuation, or expiry of license. Outstanding dues must be settled even after termination or App removal.
            </p>

            <h3 className="text-xl font-semibold">Disclaimer of Warranties</h3>

            <p>
              The Services are provided on an “as-is” and “as-available” basis without any warranties, express or implied. Use of the Platform is at your own risk, and the Company disclaims liability for any losses arising from such use.
            </p>

            <h3 className="text-xl font-semibold">Governing Law & Jurisdiction</h3>

            <p>
              These Terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Delhi.
            </p>

            <h3 className="text-xl font-semibold">Grievance Redressal Mechanism</h3>

            <p>
             <Link to="https://kisgaleasing.com" target='_blank'> Kisga Leasing and Finance Pvt Ltd.</Link> is committed to providing a transparent and efficient grievance redressal mechanism to address user concerns in a timely and fair manner. If you have any complaints, grievances, or feedback related to our Services, Platform, or lending process, you may reach out to us using the details provided below.
            </p>

            <p>
              We encourage users to raise their grievances at the earliest to enable prompt resolution. All complaints will be acknowledged and addressed in accordance with applicable laws and internal policies.
            </p>

            <h4 className="text-lg font-semibold">Level 1 – Customer Support</h4>

            <p>
              You may contact our Customer Support team with your grievance by providing relevant details such as your registered mobile number, email ID, loan reference number (if applicable), and a brief description of the issue.
            </p>

            <p>
              Email: care@b4salary.com <br />
              Phone: +91-7733866663
            </p>

            <p>
              We aim to resolve grievances within 7 (seven) working days from the date of receipt.
            </p>

            <h4 className="text-lg font-semibold">Level 2 – Grievance Officer</h4>

            <p>
              If you are not satisfied with the resolution provided by Customer Support, or if your grievance is not resolved within the stipulated timeframe, you may escalate the matter to our Grievance Officer.
            </p>

            <p>
              Grievance Officer: Vicky Gupta <br />
              Email: grievance@b4salary.com <br />
              Address: Kisga Leasing and Finance Pvt Ltd., B-7, New Multan Nagar, Paschim Vihar, New Delhi - 110056
            </p>

            <p>
              The Grievance Officer will review your complaint and endeavor to provide a final response within 15 (fifteen) working days.
            </p>

            <p>
              This grievance redressal mechanism is in compliance with applicable laws and regulatory guidelines. We value your trust and remain committed to resolving concerns in a fair, transparent, and customer-centric manner.
            </p>

            <h3 className="text-xl font-semibold">Contact Information</h3>

            <p>
              For any queries or concerns regarding these Terms, please contact us:
            </p>

            <p>
              Email: care@b4salary.com <br />
              Phone: +91-7733866663
            </p>

            <p>
              By continuing to use our Services, you confirm that you have read, understood, and accepted these Terms & Conditions.
            </p>

          </motion.div>
        </motion.div>
      </section>

      <Footer />
    </>
  )
}